"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIconBase = _interopRequireDefault(require("react-icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CategoryCodeCULTR = function CategoryCodeCULTR(props) {
  return _react.default.createElement(_reactIconBase.default, _extends({
    viewBox: "0 0 16 16"
  }, props), _react.default.createElement("g", null, _react.default.createElement("title", null, "CategoryCodeCULTR"), _react.default.createElement("path", {
    d: "M8.493,5.515a6.029,6.029,0,0,0-.466-1.828C6.96,1.8,1.92,3.155,1.938,5.318A12.3,12.3,0,0,0,3.158,8.76c.424.925,1.694,2.491,3.5,2.006a2.5,2.5,0,0,0,.668-.29A2.884,2.884,0,0,0,9.34,13.117c1.808.484,3.078-1.082,3.5-2.006a12.291,12.291,0,0,0,1.221-3.442C14.078,5.755,10.141,4.482,8.493,5.515Zm1.688,1.961a.767.767,0,0,1-.692.836.758.758,0,0,1-.79-.541c0-.054,0-.1,0-.156ZM3.429,6.431a.767.767,0,1,1,1.481-.4Zm2.8,2.725A1.239,1.239,0,0,1,4.711,8.28l2.395-.642A1.24,1.24,0,0,1,6.229,9.156ZM5.81,5.793a.767.767,0,1,1,1.482-.4Zm5.2,5.863-2.395-.642a1.24,1.24,0,0,1,2.395.642Zm.564-2.8A.767.767,0,0,1,11.52,7.77L12.661,8.8A.767.767,0,0,1,11.578,8.853Z"
  })));
};

var _default = CategoryCodeCULTR;
exports.default = _default;